import { BaseBanner } from './BaseBanner';

class Banner extends BaseBanner {
  constructor(params) {
    super(params);
    this.backgroundColor = params.backgroundColor;
  }
}

export { Banner };



// WEBPACK FOOTER //
// ./src/models/Banner.js